import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {CommonService} from "../../../services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {
  profile,
  profileData,
  selectedUserProfile
} from "../../../core/shared.selectors";
import {roles, rolesLabelMap} from "../../../constants/common.constants";
import {
  FetchProfileByUserIdRequest,
  FetchProfileRequest
} from "../../../core/shared.actions";
import {ProfileModel} from "../../../../../models/profile.model";
import * as _ from "lodash";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, AfterContentChecked,
                                         OnDestroy {

  profileAvatar: string;
  profile: ProfileModel;
  editUserDetails: boolean = false;
  editOnboardingDetails: boolean = false;
  editAdultDetails: boolean = false;
  profileLoader: boolean = false;
  hasUserId: boolean;
  loggedInUserRole: number;
  protected readonly roles = roles;
  protected readonly rolesLabelMap = rolesLabelMap;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  ngOnInit() {
    const urlParams: any = this.route.snapshot.params;
    const userId = urlParams['memberId'] || urlParams['coachId'] || urlParams['clientAdminId'] || urlParams['superAdminId'];
    this.hasUserId = userId;
    if (userId) {
      this.store.dispatch(FetchProfileByUserIdRequest({payload: {userId: +userId}}))
      this.store.select(selectedUserProfile).pipe(
        takeUntil(this.onDestroy)
      ).subscribe(data => {
        this.profileLoader = data.loading;
        this.createProfileData(data.profile)
      });
    } else {
      this.store.dispatch(FetchProfileRequest());
      this.store.select(profileData).pipe(
        takeUntil(this.onDestroy)
      ).subscribe(data => {
        this.profileLoader = data.loading;
        this.createProfileData(data.profile)
      });
    }

    const editUserDetailsStatus = +this.route.snapshot.queryParamMap.get('edit');
    this.editUserDetails = !!editUserDetailsStatus;

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

    this.store.select(profile).pipe(takeUntil(this.onDestroy))
      .subscribe(profile => {
        this.loggedInUserRole = profile?.role;
      })
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  createProfileData(data) {
    const tempData = _.cloneDeep(data)
    this.profile = tempData;
    if (this.profile) {
      this.createProfileAvatar(tempData?.firstName, tempData?.lastName);
      this.profile['phoneNumber'] = this.formatPhoneNumber(tempData?.phoneNumber)
      tempData['participants']?.forEach(e => {
        e['phoneNumber'] = this.formatPhoneNumber(e['phoneNumber']);
      });
      tempData['adults']?.forEach(e => {
        e['phoneNumber'] = this.formatPhoneNumber(e['phoneNumber']);
      });
      this.profile?.caregivers?.forEach(eachCaregiver => {
        eachCaregiver.phoneNumber = this.formatPhoneNumber(eachCaregiver.phoneNumber);

        eachCaregiver['hasHippaConsent'] = (eachCaregiver['hasHippaConsent'] == true) ? 'View' : 'Not Completed';

        eachCaregiver['isLar'] = (eachCaregiver['isLar'] == true) ? 'Yes' : 'No';
      });
    }
  }

  createProfileAvatar(firstName, lastName) {
    const firstNameFirstLetter = firstName?.substring(0, 1);
    const lastNameFirstLetter = lastName?.substring(0, 1);
    this.profileAvatar = `${firstNameFirstLetter}${lastNameFirstLetter}`
  }

  editUserDetailsView() {
    this.editUserDetails = !this.editUserDetails;
  }

  editOnboardingDetailsView(formUpdated) {
    this.editOnboardingDetails = !this.editOnboardingDetails;
  }

  editAdultDetailsView() {
    this.editAdultDetails = !this.editAdultDetails;
  }

  formatPhoneNumber(phoneNumber: string) {
    if (typeof phoneNumber === 'string') {
      const part1 = phoneNumber?.substring(0, 3);
      const part2 = phoneNumber?.substring(3, 6);
      const part3 = phoneNumber?.substring(6, 10);
      return `(${part1})${part2}-${part3}`
    } else {
      return 'N/A'
    }


  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
